import type { UTCTimestamp } from 'lightweight-charts'

// Cache timezone offsets by day string to avoid repeated `new Date()` allocs
// in hot loops (e.g. session-band computation).
const _tzCache = new Map<string, number>()
function getTzOffsetMs(date: Date): number {
  const key = date.toDateString()
  let val = _tzCache.get(key)
  if (val === undefined) {
    val = date.getTimezoneOffset() * 60_000
    _tzCache.set(key, val)
  }
  return val
}

// lightweight-charts renders UTCTimestamp values as UTC. Shift by the local TZ
// offset (computed per-timestamp so DST is handled) so the axis and crosshair
// label show the user's local wall-clock time.
export function toLocalChartTime(ms: number): UTCTimestamp {
  const offsetMs = getTzOffsetMs(new Date(ms))
  return Math.floor((ms - offsetMs) / 1000) as UTCTimestamp
}

export function fromLocalChartTime(secs: number): number {
  const approxMs = secs * 1000
  const offsetMs = getTzOffsetMs(new Date(approxMs))
  return approxMs + offsetMs
}
